export default __webpack_public_path__ + "static/media/img-0041.9a6b5a16.png";